import * as React from 'react';

import { TooltipWrapper } from '@coursera-web/cds-labs';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';
import { SvgFlashFilled } from '@coursera/coursera-ui/svg';

import { getReadableConfidenceLevel } from 'bundles/asset-admin/utils/AutoGeneratedTagUtils';

import _t from 'i18n!nls/asset-admin';

import 'css!./__styles__/AutoGeneratedImageAssetTableTag';

type InputProps = {
  confidenceLevel?: number;
  description: string;
};

const AutoGeneratedImageAssetTableTag = ({ confidenceLevel, description }: InputProps) => {
  const readableConfidenceLevel = getReadableConfidenceLevel(confidenceLevel);

  return (
    <div className="rc-AutoGeneratedImageAssetTableTag">
      <div className="flex-container">
        <TooltipWrapper tooltipId="auto-generated-accurary-level" message={description} placement="top">
          <div className="flash-icon">
            <SvgFlashFilled size={16} />
          </div>
          <div className="auto-gen-accuracy-label">
            <Typography2 component="p" variant="bodySecondary">
              <FormattedMessage
                message={_t('Auto-generated with {confidenceLevel}% accuracy')}
                confidenceLevel={readableConfidenceLevel}
              />
            </Typography2>
          </div>
        </TooltipWrapper>
      </div>
    </div>
  );
};

export default AutoGeneratedImageAssetTableTag;
